import images from 'assets/images/images'
import React from 'react'
import Select from 'react-select'
import auth from 'utils/Auth'

const ReactSelect = ({ id,labelText, options, placeholder, className, name, defaultValue, handleChange, value, isSearchable=false, disabled=false, isClearable=false, isLang = false , required=false, wrapperClass}) => {
  const customFilter = (option, searchText) => {
    if (
    option.data.label.toLocaleLowerCase('tr').includes(searchText.toLocaleLowerCase('tr'))
    ) {
    return true;
    } else {
    return false;
    }
  
  }
  return (
    <div className={`react-select gap-1 d-flex flex-column ${wrapperClass ? wrapperClass:''}`}>
      {labelText && <label className='form-control-label'>{labelText} {required && "*"}</label>}
      <Select
        id={id}
        className={className}
        placeholder={placeholder}
        options={options}
        defaultValue={defaultValue && defaultValue[0]}
        onChange={handleChange}
        isDisabled={disabled}
        //getOptionValue={option => option.value?.value}
        name={name}
        isSearchable={isSearchable}
        isClearable={isClearable}
        value={value && value}
        classNames={{
          control: () =>
            !isLang ? 'react-select-control' : `navbar-text react-select-navbar-card ${!auth.isHaveToken() ? 'h-32' : ''} cursor-pointer`,
          valueContainer: () =>
            'react-select-value',
          placeholder: () =>
            'react-select-placeholder',
          indicatorsContainer: () => 
            isLang ? 'indicators' : ''
        }}
        components={{
          DropdownIndicator: () => (
            !isLang ? <img src={images.carrotDownFill} /> : ''
          ),
        }}
        formatOptionLabel={country => (
          <div className="countrySelect-sub">
           {country.image && <span className='react-select-control-image' dangerouslySetInnerHTML={{__html:country.image}}></span>}
            <span>{country.label}</span>
          </div>
        )}
        filterOption={customFilter}
      />
    </div>

  )
}

export default ReactSelect